import { BrowserModule } from '@angular/platform-browser';
import {NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RatingModule } from 'ngx-bootstrap/rating';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { StyleGuideComponent } from './shared/style-guide/style-guide.component';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { AlertComponent } from './services/alert/alert.component';
import { DataService } from './services/data.service';
import { AlertService } from './services/alert/alert.service';
import { LoadingComponent } from './services/loading/loading.component';
import { LoadingService } from './services/loading/loading.service';
import { LoginValidateComponent } from './features/login-validate/login-validate.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SsoComponent } from './features/sso/sso.component';
import { HomeComponent } from './features/home/home.component';
import { UserService } from './services/user/user.service';
import { RoutingStateService } from './services/routing-state.service';
import { SsoService } from './features/sso/sso.service';
import { NotFoundComponent } from './shared/not-found/not-found.component';
import { SandboxComponent } from './features/sandbox/sandbox.component';
import { AgencyUserComponent } from './features/agency-user/agency-user.component';
import { AgencyUserService } from './features/agency-user/agency-user.service';
import { AgencyProfileComponent } from './features/agency-profile/agency-profile.component';
import {AgencyTokenAPIComponent} from './features/agency-token-api/agency-token-api.component';
import { TspProfileComponent } from './features/tsp-profile/tsp-profile.component';
import { AgencytspsearchComponent } from './features/agencytspsearch/agencytspsearch.component';
import { CustomerRegistrationService } from './services/customer-registration/customer-registration.service';
import { LoggerService } from './shared/common-components/logger.service';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { CustomerRegistrationComponent } from './features/customer-registration/customer-registration.component';
import { CustomerApprovalListComponent } from './features/customer-approval-list/customer-approval-list.component';
import { CustomerApprovalComponent } from './features/customer-approval/customer-approval.component';
import { FaicListComponent } from './features/faic-list/faic-list.component';
import { FrtSummaryListComponent } from './features/frt-summary-list/frt-summary-list.component';
import { FrtSummaryTspListComponent } from './features/frt-summary-tsp-list/frt-summary-tsp-list.component';
import { HhgSummaryListComponent } from './features/hhg-summary-list/hhg-summary-list.component';
import { AgencyDropdownComponent } from './shared/common-components/agency-dropdown/agency-dropdown.component';
import { AgencyDropdownService } from './shared/common-components/agency-dropdown/agency-dropdown.service';
import { HhgCarrierScopeComponent } from './features/hhg-carrier-scope/hhg-carrier-scope.component';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { ConfirmationModalComponent } from './shared/common-components/confirmation-modal/confirmation-modal.component';
import { LandingpageComponent } from './shared/landingpage/landingpage.component';
import { ReportMailingListComponent } from './features/report-mailing-list/report-mailing-list.component';
import { ReportsService } from './services/reports/reports.service';
import { AuthGuard } from './auth-guards';
import { RouteGuard } from './auth-guards/route-guard';
import { CanDeactivateGuard } from './auth-guards/can-deactivate-guard.service';
import { WorkGroupAdminComponent } from './features/work-group-admin/work-group-admin.component';
import { AdminGuard } from './auth-guards/admin.guard';
import { RatefileOpenComponent } from './features/ratefile-open/ratefile-open.component';
import { RatefileTspExtComponent } from './features/ratefile-tsp-ext/ratefile-tsp-ext.component';
import { RatesSroMaintenanceComponent } from './features/rates-sro-maintenance/rates-sro-maintenance.component';
import { CarrierRateProcurementComponent } from './features/carrier-rate-procurement/carrier-rate-procurement.component';
import { DatePipe } from '@angular/common';
import { RatefileOpenService } from './services/ratefile-open/ratefile-open.service';
import { RatefileTspExtService } from './services/ratefile-tsp-ext/ratefile-tsp-ext.service';
import { CarrierApprovalComponent } from './features/carrier-approval/carrier-approval.component';
import { CarrierProfileComponent } from './features/carrier-profile/carrier-profile.component';
import { HhgCarrierRateFilingComponent } from './features/hhg-carrier-rate-filing/hhg-carrier-rate-filing.component';
import { RateCarryoverComponent} from './features/hhg-rate-carryover/rate-carryover.component';
import { OrganizationService } from './services/organization/organization.service';
import { WorkGroupsService } from './services/work-groups/work-groups.service';
import { DownloadComponent } from './features/download/download.component';
import {DownloadCurrentPastRateComponent} from './features/download-current-past-rates/download-current-past-rates.component';
import { DownloadAnchorTagComponent } from './features/download/download-file.component';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { HhgCarrierRateFilingService } from './features/hhg-carrier-rate-filing/hhg-carrier-rate-filing.service';
import { FrtRateQueryComponent } from './features/frt-rate-query/frt-rate-query.component';
import { RatesSroMasterService } from './services/rates-sro-master/rates-sro-master.service';
import { OktaComponent } from './features/okta/okta.component';
import { NumbersOnlyDirective } from './shared/common-components/numbers-only.directive';
import { AgGridResizeDirective } from './shared/common-components/ag-grid-resize.directive';
import { HhgRateQueryComponent } from './features/hhg-rate-query/hhg-rate-query.component';
import { RateDunsComponent} from './features/hhg-rate-duns/rate-duns.component';
import { CarrierRateProcurementService } from './services/carrier-rate-procurement/carrier-rate-procurement.service';
import { HhgRateQueryResultsComponent } from './features/hhg-rate-query-results/hhg-rate-query-results.component';
import { UserProfileComponent } from './features/user-profile/user-profile.component';
import { AccountInfoComponent } from './features/account-info/account-info.component';
import {HhgRatesUploadComponent} from './features/hhg-rates-upload/hhg-rates-upload.component';
import { FrtAccessorialsMasterService } from './services/frt-accessorials-master/frt-accessorials-master.service';
import { FrtDeliveryExceptionCodesService } from './services/frt-delivery-exception-codes/frt-delivery-exception-codes.service';
import { HhgRateGlobalUpdateComponent } from './features/hhg-rate-global-update/hhg-rate-global-update.component';
import { HhgRatesDownloadComponent } from './features/hhg-rates-download/hhg-rates-download.component';
import { ForgotPasswordComponent } from './features/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './features/reset-password/reset-password.component';
import { AgGridModule } from 'ag-grid-angular';
import { HhgRateDownloadService } from './features/hhg-rates-download/hhg-rate-download.service';
import { NewOktaUserComponent } from './features/new-okta-user/new-okta-user.component';
import { HhgOnlineBookShipmentComponent } from './features/hhg-online-book-shipment/hhg-online-book-shipment.component';
import { AccessorialsRatesEditComponent } from './features/accessorials-rates-edit/accessorials-rates-edit.component';
import { CommonSideBarComponent } from './shared/common-side-bar/common-side-bar.component';
import { HhgShipmentAddressTemplateComponent } from './features/hhg-shipment-address-template/hhg-shipment-address-template.component';
import { HhgRatesViewComponent } from './features/hhg-rates-view/hhg-rates-view.component';
import { FrtRateDownloadService } from './features/frt-rates-download/frt-rate-download.service';
import { HhgShipmentAccessorialsComponent } from './features/hhg-shipment-accessorials/hhg-shipment-accessorials.component';
import { ShipmentAuditTrailComponent } from './features/shipment-audit-trail/shipment-audit-trail.component';
import { ShipmentAuditTrailService } from './services/shipment-audit-trail/shipment-audit-trail.service';
import { HhgShipmentAccessorialAdditionalinfoComponent } from './features/hhg-shipment-accessorial-additionalinfo/hhg-shipment-accessorial-additionalinfo.component';
import { HhgExtraPickupdeliveryAddressComponent } from './features/hhg-extra-pickupdelivery-address/hhg-extra-pickupdelivery-address.component';
import { ShipmentReviewComponent} from './features/shipment-review/shipment-review.component';
import { ShipmentReviewService } from './services/shipment-review/shipment-review.service';
import {HhgOnlineBookShipmentService} from './features/hhg-online-book-shipment/hhg-online-book-shipment.service';
import { ShipmentControlComponent } from './features/shipment-control/shipment-control.component';
import { FrtOnlineBookShipmentComponent } from './features/frt-online-book-shipment/frt-online-book-shipment.component';
import { ShipperInformationComponent } from './shared/common-components/shipment/shipper-information/shipper-information.component';
import { TspInformationComponent } from './shared/common-components/shipment/tsp-information/tsp-information.component';
import { PreShipmentSurveyComponent } from './shared/common-components/shipment/pre-shipment-survey/pre-shipment-survey.component';
import {ButtonRendererComponent} from './features/frt-rates-download/ButtonRendererComponent';
import {FrtRatesBidcyclesDuplicateButtonRendererComponent} from './features/frt-rates-bidcycles/frt-rates-bidcycles-duplicate-button-renderer.component';
import {HhgRatesBidcyclesDuplicateButtonRendererComponent} from './features/hhg-rates-bidcycles/hhg-rates-bidcycles-duplicate-rate-filling';
import { ButtonChargeCodeRendererComponent } from './shared/common-components/shipment/frt-shipment-package-info/frt-appropriation-charge-codes/ButtonChargeCodeRendererComponent';
import {ButtonRendererComponent2} from './features/document-management/btnrender';
import { FrtAccesorialsTableComponent } from './features/frt-accesorials-table/frt-accesorials-table.component';
import { FrtShipmentAccessorialsComponent } from './features/frt-shipment-accessorials/frt-shipment-accessorials.component';
import {DateFormatPipe} from './features/hhg-rate-edit/my-date-formatter';
import {RoundPipe} from './features/hhg-rate-query/round-pipe';
import { FrtQueryResultsComponent } from './features/frt-query-results/frt-query-results.component';
import {NgIdleKeepaliveModule} from '@ng-idle/keepalive';
import { BillofladingInformationComponent } from './features/billoflading-information/billoflading-information.component';
import { AppropriationChargeableCodeDialogComponent } from './features/appropriation-chargeable-code-dialog/appropriation-chargeable-code-dialog.component';
import { BillofladingAddressesComponent } from './features/billoflading-addresses/billoflading-addresses.component';
import { BillofladingShipmentInformationComponent } from './features/billoflading-shipment-information/billoflading-shipment-information.component';
import { BillofladingFinalizationComponent } from './features/billoflading-finalization/billoflading-finalization.component';
import { HhgDelinquencyReportComponent } from './features/delinquency-report/hhg-delinquency-report/hhg-delinquency-report.component';
import { DelinquencyReportComponent } from './features/delinquency-report/delinquency-report/delinquency-report.component';
import { FrtDelinquencyReportComponent } from './features/delinquency-report/frt-delinquency-report/frt-delinquency-report.component';
import { CommonAddressComponent } from './features/billoflading-addresses/common-address/common-address.component';
import { MasterDataAdminComponent } from './features/masterdata-admin/masterdata-admin.component';
import { HhgIffSummaryComponent } from './features/iff-shipment/hhg-iff-summary/hhg-iff-summary.component';
import { FrtIffSummaryComponent } from './features/iff-shipment/frt-iff-summary/frt-iff-summary.component';
import { HhgIffDetailComponent } from './features/iff-shipment/hhg-iff-detail/hhg-iff-detail.component';
import { FrtIffDetailComponent } from './features/iff-shipment/frt-iff-detail/frt-iff-detail.component';
import { SitIffSummaryComponent } from './features/iff-shipment/sit-iff-summary/sit-iff-summary.component';
import { IffShipmentSummaryComponent } from './features/iff-shipment/iff-shipment-summary/iff-shipment-summary.component';
import { IffShipmentSummaryService } from './services/iff-shipment-summary/iff-shipment-summary.service';
import { IffShipmentDetailsService } from './services/iff-shipment-details/iff-shipment-details.service';
import { FrtShipmentHazmatModalComponent } from './shared/common-components/shipment/frt-shipment-item-modal/frt-shipment-item-modal.component';
import { TextRendererComponent } from './shared/common-components/shipment/text-renderer/text-renderer.component';
import { CheckboxRendererComponent } from './shared/common-components/shipment/checkbox-renderer/checkbox-renderer.component';
import { FrtShipmentPackageInfoModalComponent } from './shared/common-components/shipment/frt-shipment-package-info/frt-shipment-package-info.component';
import { AppTermsConditionsComponent } from './shared/app-terms-conditions/app-terms-conditions.component';
import { FrtShipmentAccessorialAdditionalInfoComponent } from './features/frt-shipment-accessorial-additionalinfo/frt-shipment-accessorial-additionalinfo.component';
import { Gsa3080InitiationComponent } from './features/gsa-3080-initiation/gsa-3080-initiation.component';
import { HhgTemplateDownloadComponent } from './features/hhg-template-download/hhg-template-download.component';
import { IffDetailHeaderComponent } from './features/iff-shipment/iff-detail-header/iff-detail-header.component';
import { AddItemRendererComponent } from './shared/common-components/shipment/add-item-renderer/add-item-renderer.component';
import { FRTBillOfLadingComponent } from './features/frt-bill-of-lading/frt-bill-of-lading.component';
import { FRTBillofladingInformationComponent } from './features/frt-billoflading-information/frt-billoflading-information.component';
import { FRTBillofladingShipmentInformationComponent } from './features/frt-billoflading-shipment-information/frt-billoflading-shipment-information.component';
import { FRTBillofladingFinalizationComponent } from './features/frt-billoflading-finalization/frt-billoflading-finalization.component';
import { FrtShipmentSealPurchaseComponent } from './features/frt-shipment-seal-purchase/frt-shipment-seal-purchase.component';
import { FrtRateFilingInitialComponent } from './features/frt-rate-filing-initial/frt-rate-filing-initial.component';
import { CarrierLocalAgentsComponent } from './features/carrier-local-agents/carrier-local-agents.component';
import { NegativeShipmentReportSubmissionComponent } from './features/iff-shipment/negative-shipment-report-submission/negative-shipment-report-submission.component';
import { HhgRatefileOpenComponent } from './features/hhg-ratefile-open/hhg-ratefile-open.component';
import { ShipmentAddressesComponent } from './features/shipment-addresses/shipment-addresses.component';
import { ShipmentAddressComponent } from './features/shipment-addresses/shipment-address/shipment-address.component';
import { ShipmentPreferredAddressesComponent } from './features/shipment-addresses/shipment-preferred-addresses/shipment-preferred-addresses.component';
import { FrtAppChargeCodesComponent } from './shared/common-components/shipment/frt-shipment-package-info/frt-appropriation-charge-codes/frt-app-charge-codes.component';
import { SurveyThirtyeightyComponent } from './features/survey-thirtyeighty/survey-thirtyeighty.component';
import { EvaluationFormComponent } from './features/evaluation-form/evaluation-form.component';
import { AdminEmployeeThirtyEightyComponent } from './features/admin-employee-thirtyeighty/admin-employee-thirtyeighty.component';
import {FrtOnetimeShipmentComponent} from './features/frt-onetime-shipment/frt-onetime-shipment.component';
import { HhgBillOfLadingComponent } from './features/hhg-bill-of-lading/hhg-bill-of-lading.component';
import { HhgRatesCsvDownloadComponent } from './features/hhg-rates-csv-download/hhg-rates-csv-download.component';
import { FrtRatesCsvDownloadComponent } from './features/frt-rates-csv-download/frt-rates-csv-download.component';
import { HhgBillOfLadingService } from './services/hhg-bill-of-lading/hhg-bill-of-lading.service';
import { HhgComprehensiveReportComponent } from './features/iff-shipment/hhg-comprehensive-report/hhg-comprehensive-report.component';
import { FrtComprehensiveReportComponent } from './features/iff-shipment/frt-comprehensive-report/frt-comprehensive-report.component';
import { CarrierReportComponent } from './features/hhg-survey-carrier-report/carrier-report.component';
import { AmcReportComponent } from './features/amc-report/amc-report.component';
import { SummaryReportComponent } from './features/summary-report/summary-report.component';
import { SurveyAdminReportComponent } from './features/survey-admin-report/survey-admin-report.component';
import { AdminSurveyThirtyeightyComponent } from './features/admin-survey-thirtyeighty/admin-survey-thirtyeighty.component';
import {CstTimePipe} from './shared/cst-time.pipe';
import { HhgScopeReportDownloadComponent } from './features/hhg-scope-report-download/hhg-scope-report-download.component';
import { HhgCarrierTspScopeComponent } from './features/hhg-carrier-tsp-scope/hhg-carrier-tsp-scope.component';
import { ShipmentDeliveryComponent } from './features/shipment-delivery/shipment-delivery.component';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { UserSelectionComponent } from './shared/user-selection/user-selection.component';
import { ViewDocumentPackageComponent } from './features/view-document-package/view-document-package.component';
import {UserSelectionService} from './shared/user-selection/user-selection-service';
import {DocumentManagementComponent} from './features/document-management/document-management.component';
import { FrtDocumentManagementComponent } from './features/frt-document-management/frt-document-management.component';
import {RatesFrtSroMaintenanceComponent } from './features/rates-frt-sro-maintenance/rates-frt-sro-maintenance.component';
import { FrtRatesBidcyclesComponent } from './features/frt-rates-bidcycles/frt-rates-bidcycles.component';
import { ButtonRendererApproveComponent } from './features/document-management/btnrenderapprove';
import { ButtonRendererRejectComponent } from './features/document-management/btnrenderreject';
import { ButtonRendererDownloadComponent } from './features/document-management/btnrenderdownload';
import { HhgRatesBidcyclesComponent } from './features/hhg-rates-bidcycles/hhg-rates-bidcycles.component';
import { BreadCrumbNavigationComponent } from './shared/bread-crumb-navigation/bread-crumb-navigation.component';
import { ExtendExpiryDatesComponent } from './features/extend-expiry-dates/extend-expiry-dates.component';
import { HhgRatefileTspExtComponent } from './features/hhg-ratefile-tsp-ext/hhg-ratefile-tsp-ext.component';
import { FrtRatefileTspExtComponent } from './features/frt-ratefile-tsp-ext/frt-ratefile-tsp-ext.component';
import { SitComprehensiveReportComponent } from './features/iff-shipment/sit-comprehensive-report/sit-comprehensive-report.component';
import { ThirthyeightyUploadComponent } from './features/thirthyeighty-upload/thirthyeighty-upload.component';
import { ThirtyEightyDownloadComponent } from './features/thirtyeighty-download/thirtyeighty-download.component';
import {CarrierContactInfoComponent} from './features/carrier-contact-info/carrier-contact-info.component';
import { CellRenderer } from './features/delinquency-report/cell-rendering/cell-renderer.component';
import { IconRenderer } from './features/delinquency-report/cell-rendering/icon-renderer.component';
import { CommonModule } from '@angular/common';
import { CellRenderingService } from './features/delinquency-report/cell-rendering/cell-rendering.service';
import { UserPreferencesComponent } from './features/user-preferences/user-preferences.component';
import { UserPrefHeadComponent } from './features/user-pref-head/user-pref-head.component';
import { UserPrefBodyComponent } from './features/user-pref-body/user-pref-body.component';
import { StyleGuideUswdsComponent } from './shared/style-guide-uswds/style-guide-uswds.component';
import { BidCycleService } from './features/hhg-rate-duns/bidcycle.service';
import { AdminThirtyEightyService } from './features/admin-thirty-eighty-services/admin-thirty-eighty-service.service';
import { HelpComponent } from './shared/help/help.component';
import { DocMgmtReportComponent } from './features/doc-mgmt-report/doc-mgmt-report.component';
import { FRTTempNonUseDocMgmtReportComponent } from './features/frt-temp-non-use-tsps-doc-mgmt-rpt/frt-temp-non-use-tsps-doc-mgmt-rpt.component';
import { LoginHistoryReportComponent } from './features/login-history-report/login-history-report.component';
import { HhgShipmentReviewComponent } from './features/hhg-shipment-review/hhg-shipment-review.component';
import { HhgShipmentReviewResultsComponent } from './features/hhg-shipment-review-results/hhg-shipment-review-results.component';
import { FrtShipmentReviewComponent } from './features/frt-shipment-review/frt-shipment-review.component';
import { FrtShipmentReviewResultsComponent } from './features/frt-shipment-review-results/frt-shipment-review-results.component';
import { NotificationsPreferencesComponent } from './features/notifications-preferences/notifications-preferences.component';
import { NotifyUsersComponent } from './features/notify-users/notify-users.component';
import { MultiFileUploadComponent } from './features/multi-file-upload/multi-file-upload.component';
import { UploadImageComponent } from './features/upload-image/upload-image.component';
import { BroadcastMessagesComponent } from './features/broadcast-messages/broadcast-messages.component';
import { HhgUabCalculatorComponent} from './features/hhg-uab-calculator/hhg-uab-calculator.component';
import { TspStatusPortalComponent } from './features/tsp-status-portal/tsp-status-portal.component';
import {EnableSupressNotificationsComponent} from './features/enable-supress-notifications/enable-supress-notifications.component';
import { HhgRatesQueryReportComponent } from './features/hhg-rates-query-report/hhg-rates-query-report.component';
import { FrtRatesQueryReportComponent } from './features/frt-rates-query-report/frt-rates-query-report.component';
import { OrganizationUpdateMessageComponent } from './features/organization-update-message/organization-update-message.component';
import { NotificationPreferenceViewComponent } from './features/notification-preference-view/notification-preference-view.component';
import { TspAgyProfileAuditTrailComponent } from './features/tspagy-profile-audit-trail/tspagy-profile-audit-trail.component';
import { S3AdminPortalAuditTrailComponent } from './features/s3-admin-portal-audit-trail/s3-admin-portal-audit-trail.component';
import { S3AdminPortalComponent } from './features/s3-admin-portal/s3-admin-portal.component';
import {DownloadButtonRendererComponent} from './features/s3-admin-portal/download-renderer.component';
import {TwoDigitDecimalDirective} from './shared/common-components/two-digit-decimal.directive';
import {MasterDataAdminCountryAuditTrailComponent} from './features/masterdata-admin-country-audit-trail/masterdata-admin-country-audit-trail.component';
import { NonUseTspComponent } from './features/non-use-tsp/non-use-tsp.component';
import { ViewInterstateScopeComponent } from './features/view-interstate-scope/view-interstate-scope.component';
import {AnnouncementsComponent} from "./shared/announcements/announcements.component";
import { SitDelinquencyReportComponent } from './features/delinquency-report/sit-delinquency-report/sit-delinquency-report.component';
import {TspScopeComponent} from "./features/tsp-scope/tsp-scope.component";
import {TspSitShpmntRptStatusComponent} from "./features/tsp-sit-shpmnt-rpt-status/tsp-sit-shpmnt-rpt-status.component";
import {TspHhgShpmntRptStatusComponent} from "./features/tsp-hhg-shpmnt-rpt-status/tsp-hhg-shpmnt-rpt-status.component";
import { UserRecertificationComponent } from './features/user-recertification/user-recertification.component';
import {TspFrtStatusPortalComponent} from "./features/tsp-frt-status-portal/tsp-frt-status-portal.component";
import {
  HhgQuarterlyReportsComponent
} from "./features/administrative-fee-payments/hhg-quarterly-reports/hhg-quarterly-reports.component";
import {
  PayShipmentInvoicesModalComponent
} from "./features/administrative-fee-payments/pay-shipment-invoices-modal/pay-shipment-invoices-modal.component";
import {HhgRateEditComponent} from "./features/hhg-rate-edit/hhg-rate-edit.component";
import { UploadComponent } from './features/upload/upload.component';
import { FrtSyncadaShipmentInvoicesComponent } from './features/syncada-payment/frt-syncada-shipment-invoices/frt-syncada-shipment-invoices.component';
import {DateRendererComponent} from "./features/iff-rates/date-renderer.component";
import { StarRatingRendererComponent} from './shared/common-components/shipment/star-rating-renderer/star-rating-renderer.component';
import { DocuSignModalComponent } from './features/docusign/docusign-modal.component';
import { DocuSignCallBackComponent } from './features/docusign/docusign-callback.component';
import { CarriertospecialtycodeService } from './services/carrier-to-specialty-code/carriertospecialtycode.service';
@NgModule({ declarations: [
        AppComponent,
        AnnouncementsComponent,
        StyleGuideComponent,
        HeaderComponent,
        FooterComponent,
        AlertComponent,
        LoadingComponent,
        LoginValidateComponent,
        SsoComponent,
        HomeComponent,
        NotFoundComponent,
        SandboxComponent,
        LandingpageComponent,
        AgencyUserComponent,
        AgencyProfileComponent,
        AgencyTokenAPIComponent,
        TspProfileComponent,
        AgencytspsearchComponent,
        CustomerRegistrationComponent,
        CustomerApprovalListComponent,
        CustomerApprovalComponent,
        FaicListComponent,
        FrtSummaryListComponent,
        FrtSummaryTspListComponent,
        HhgSummaryListComponent,
        AgencyDropdownComponent,
        HhgCarrierScopeComponent,
        AgencyDropdownComponent,
        ReportMailingListComponent,
        WorkGroupAdminComponent,
        RatefileOpenComponent,
        RatefileTspExtComponent,
        RatesSroMaintenanceComponent,
        CarrierRateProcurementComponent,
        CarrierApprovalComponent,
        ConfirmationModalComponent,
        CarrierProfileComponent,
        HhgCarrierRateFilingComponent,
        RateCarryoverComponent,
        DownloadComponent,
        DownloadCurrentPastRateComponent,
        DownloadAnchorTagComponent,
        FrtRateQueryComponent,
        OktaComponent,
        HhgRateQueryComponent,
        NumbersOnlyDirective,
        TwoDigitDecimalDirective,
        AgGridResizeDirective,
        RateDunsComponent,
        HhgRateQueryResultsComponent,
        UserProfileComponent,
        AccountInfoComponent,
        HhgRatesUploadComponent,
        HhgRateGlobalUpdateComponent,
        HhgRatesDownloadComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        NewOktaUserComponent,
        HhgOnlineBookShipmentComponent,
        AccessorialsRatesEditComponent,
        CommonSideBarComponent,
        HhgShipmentAddressTemplateComponent,
        HhgRatesViewComponent,
        HhgShipmentAccessorialsComponent,
        ShipmentAuditTrailComponent,
        HhgShipmentAccessorialAdditionalinfoComponent,
        HhgExtraPickupdeliveryAddressComponent,
        ShipmentReviewComponent,
        ShipmentControlComponent,
        FrtOnlineBookShipmentComponent,
        ShipperInformationComponent,
        TspInformationComponent,
        PreShipmentSurveyComponent,
        ButtonRendererComponent,
        ButtonRendererComponent2,
        FrtRatesBidcyclesDuplicateButtonRendererComponent,
        HhgRatesBidcyclesDuplicateButtonRendererComponent,
        ButtonChargeCodeRendererComponent,
        ButtonRendererApproveComponent,
        ButtonRendererRejectComponent,
        ButtonRendererDownloadComponent,
        FrtAccesorialsTableComponent,
        FrtShipmentAccessorialsComponent,
        RoundPipe,
        DateFormatPipe,
        FrtQueryResultsComponent,
        BillofladingInformationComponent,
        AppropriationChargeableCodeDialogComponent,
        BillofladingAddressesComponent,
        BillofladingShipmentInformationComponent,
        BillofladingFinalizationComponent,
        HhgDelinquencyReportComponent,
        SitDelinquencyReportComponent,
        DelinquencyReportComponent,
        FrtDelinquencyReportComponent,
        CommonAddressComponent,
        IffShipmentSummaryComponent,
        MasterDataAdminComponent,
        HhgIffSummaryComponent,
        FrtIffSummaryComponent,
        HhgIffDetailComponent,
        FrtIffDetailComponent,
        SitIffSummaryComponent,
        FrtShipmentAccessorialAdditionalInfoComponent,
        AppTermsConditionsComponent,
        Gsa3080InitiationComponent,
        FrtShipmentHazmatModalComponent,
        TextRendererComponent,
        CheckboxRendererComponent,
        FrtShipmentPackageInfoModalComponent,
        HhgTemplateDownloadComponent,
        IffDetailHeaderComponent,
        AddItemRendererComponent,
        FRTBillOfLadingComponent,
        FRTBillofladingInformationComponent,
        FRTBillofladingShipmentInformationComponent,
        FRTBillofladingFinalizationComponent,
        FrtShipmentSealPurchaseComponent,
        FrtRateFilingInitialComponent,
        CarrierLocalAgentsComponent,
        NegativeShipmentReportSubmissionComponent,
        HhgRatefileOpenComponent,
        ShipmentAddressesComponent,
        AdminEmployeeThirtyEightyComponent,
        ShipmentAddressComponent,
        ShipmentPreferredAddressesComponent,
        FrtAppChargeCodesComponent,
        SurveyThirtyeightyComponent,
        EvaluationFormComponent,
        FrtOnetimeShipmentComponent,
        EvaluationFormComponent,
        HhgBillOfLadingComponent,
        HhgRatesCsvDownloadComponent,
        FrtRatesCsvDownloadComponent,
        HhgComprehensiveReportComponent,
        FrtComprehensiveReportComponent,
        CarrierReportComponent,
        AmcReportComponent,
        SummaryReportComponent,
        SurveyAdminReportComponent,
        AdminSurveyThirtyeightyComponent,
        CstTimePipe,
        HhgScopeReportDownloadComponent,
        HhgCarrierTspScopeComponent,
        ShipmentDeliveryComponent,
        UserSelectionComponent,
        ViewDocumentPackageComponent,
        DocumentManagementComponent,
        FrtDocumentManagementComponent,
        RatesFrtSroMaintenanceComponent,
        FrtRatesBidcyclesComponent,
        HhgRatesBidcyclesComponent,
        BreadCrumbNavigationComponent,
        ExtendExpiryDatesComponent,
        HhgRatefileTspExtComponent,
        FrtRatefileTspExtComponent,
        SitComprehensiveReportComponent,
        ThirthyeightyUploadComponent,
        ThirtyEightyDownloadComponent,
        CarrierContactInfoComponent,
        CellRenderer,
        IconRenderer,
        UserPreferencesComponent,
        UserPrefHeadComponent,
        UserPrefBodyComponent,
        StyleGuideUswdsComponent,
        HelpComponent,
        DocMgmtReportComponent,
        FRTTempNonUseDocMgmtReportComponent,
        LoginHistoryReportComponent,
        HhgShipmentReviewComponent,
        HhgShipmentReviewResultsComponent,
        FrtShipmentReviewComponent,
        FrtShipmentReviewResultsComponent,
        NotificationsPreferencesComponent,
        NotifyUsersComponent,
        MultiFileUploadComponent,
        UploadImageComponent,
        BroadcastMessagesComponent,
        HhgUabCalculatorComponent,
        TspFrtStatusPortalComponent,
        TspStatusPortalComponent,
        EnableSupressNotificationsComponent,
        HhgRatesQueryReportComponent,
        FrtRatesQueryReportComponent,
        OrganizationUpdateMessageComponent,
        NotificationPreferenceViewComponent,
        TspAgyProfileAuditTrailComponent,
        S3AdminPortalAuditTrailComponent,
        S3AdminPortalComponent,
        DownloadButtonRendererComponent,
        DateRendererComponent,
        StarRatingRendererComponent,
        MasterDataAdminCountryAuditTrailComponent,
        NonUseTspComponent,
        ViewInterstateScopeComponent,
        TspScopeComponent,
        TspSitShpmntRptStatusComponent,
        TspHhgShpmntRptStatusComponent,
        UserRecertificationComponent,
        HhgQuarterlyReportsComponent,
        PayShipmentInvoicesModalComponent,
        FrtSyncadaShipmentInvoicesComponent,
        DocuSignModalComponent,
        DocuSignCallBackComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    bootstrap: [AppComponent], imports: [BrowserModule,
        RatingModule.forRoot(),
        AppRoutingModule,
        TooltipModule.forRoot(),
        PopoverModule.forRoot(),
        AccordionModule.forRoot(),
        TabsModule.forRoot(),
        BsDropdownModule.forRoot(),
        ButtonsModule.forRoot(),
        ModalModule.forRoot(),
        BsDropdownModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        AgGridModule,
        PaginationModule.forRoot(),
        // TreeModule,
        TypeaheadModule.forRoot(),
        BsDatepickerModule.forRoot(),
        ProgressbarModule.forRoot(),
        NgIdleKeepaliveModule.forRoot(),
        TimepickerModule.forRoot(),
        // DateTimePickerModule,
        BrowserAnimationsModule,
        CommonModule,
        HhgRateEditComponent,
        UploadComponent], providers: [
        DataService,
        DatePipe,
        AlertService,
        LoadingService,
        SsoService,
        UserService,
        BidCycleService,
        AdminThirtyEightyService,
        ReportsService,
        CustomerRegistrationService,
        RatefileOpenService,
        RatefileTspExtService,
        LoggerService,
        AgencyDropdownService,
        AgencyUserService,
        AuthGuard,
        RouteGuard,
        CanDeactivateGuard,
        AdminGuard,
        OrganizationService,
        WorkGroupsService,
        HhgCarrierRateFilingService,
        RatesSroMasterService,
        CarrierRateProcurementService,
        FrtAccessorialsMasterService,
        FrtDeliveryExceptionCodesService,
        HhgRateDownloadService,
        FrtRateDownloadService,
        FrtRateDownloadService,
        HhgOnlineBookShipmentService,
        ShipmentAuditTrailService,
        ShipmentReviewService,
        IffShipmentSummaryService,
        IffShipmentDetailsService,
        HhgBillOfLadingService,
        UserSelectionService,
        CellRenderingService,
        CarriertospecialtycodeService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
